import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [userId, setUserId] = useState(() => localStorage.getItem("ks_user_id") || "");

  useEffect(() => {
    const ensureUser = async () => {
      if (!userId) {
        try {
          const { data } = await api.post("/users", { name: "", email: "", phone: "" });
          localStorage.setItem("ks_user_id", data.id);
          setUserId(data.id);
        } catch (e) {
          // intentionally silent — non-blocking init
        }
      }
    };
    ensureUser();
  }, [userId]);

  return (
    <UserContext.Provider value={{ userId, setUserId }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
